import { render, staticRenderFns } from "./ServiceTerm.vue?vue&type=template&id=673e0a83&"
import script from "./ServiceTerm.vue?vue&type=script&lang=js&"
export * from "./ServiceTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports